module.exports = __webpack_public_path__ + "static/img/home_yali_photo4@2x.1d2d159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_yali_photo4@2x.png
// module id = N+q1
// module chunks = 0